export default __webpack_public_path__ + "static/media/logo.02268281.png";